import { createContext } from 'react';

export const ScrollRootHeightContext = createContext<number | null>(null);

export const ScrollRootHeightContextProvider = ScrollRootHeightContext.Provider;
